module.exports = __webpack_public_path__ + "static/media/uninstall-sad-face-monochromatic.0a7d48a2.png";